exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*$vs-colors: (\n        lightest: rgba(60, 60, 60, 0.26),\n        light: rgba(60, 60, 60, 0.5),\n        dark: #333,\n        darkest: rgba(0, 0, 0, .15),\n) !default;*/", ""]);

// exports
